import { Controller } from '@hotwired/stimulus';
import {
  grantedCategoriesFromConsentData,
  notifyFromConsentResponse,
  recreateScripts,
} from '../application/common/cookie_consent';

const PROVIDERS = {
  consent_studio: {
    event: 'consent-studio__updated',
    // Consent Studio: functional is strictly necessary / always required.
    // Only analytics + marketing are optional opt-ins.
    optionalCategories: ['analytics', 'marketing'],
  },
};

export function acceptedFromVendorCategories(grantedNames, optionalCategories) {
  const granted = Array.isArray(grantedNames) ? grantedNames : [];
  const optional = optionalCategories || PROVIDERS.consent_studio.optionalCategories;

  return optional.some((name) => granted.includes(name));
}

export default class extends Controller {
  static values = { provider: String };

  connect() {
    this.config = PROVIDERS[this.providerValue];
    if (!this.config) {
      return;
    }

    this.boundSync = this.sync.bind(this);
    window.addEventListener(this.config.event, this.boundSync);
  }

  disconnect() {
    if (this.config) {
      window.removeEventListener(this.config.event, this.boundSync);
    }
  }

  sync(event) {
    const grantedNames = event && event.detail && event.detail.categories;
    if (!Array.isArray(grantedNames)) {
      return;
    }

    const path = acceptedFromVendorCategories(grantedNames, this.config.optionalCategories)
      ? '/cookies/accept'
      : '/cookies/revoke';

    this.postConsent(path);
  }

  async postConsent(path) {
    const response = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      credentials: 'same-origin',
      body: '{}',
    });

    const data = await response.json();
    notifyFromConsentResponse(data);

    if (path === '/cookies/accept') {
      recreateScripts(grantedCategoriesFromConsentData(data));
    }
  }
}
